export default {
      id: "zoomOut-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#zoomOut-usage",
      toString: function () {
        return this.url;
      }
    }